import Preview from '../facebook/Preview'
import store from '../vuex/store'
import * as Sentry from '@sentry/browser'
import moment from 'moment'

function countTotal (insights) {
  const keys = ['spend', 'reach', 'actions', 'clicks', 'impressions']
  if (!insights.length) return {}
  let total = {}
  keys.forEach(key => {
    total[key] = 0
    insights.forEach(item => {
      if (!item.hasOwnProperty(key)) item[key] = 0
      total[key] += Number(item[key])
    })
  })
  return total
}
function getMessagePreview (params) {
  let user = getCurrentUser()
  let facebook = new Preview(user, params)
  if (params.file) {
    return new Promise(resolve => {
      resolve(facebook.addImage())
    })
      .then(res => {
        params.image_url = res.url
        facebook = new Preview(user, params)
        return facebook.getAdPreview()
      })
      .then(res => res)
  }
  return new Promise(resolve => {
    resolve(facebook.getAdPreview())
  })
    .then(res => res)
    .catch(err => {
      const error = JSON.parse(err.message)
      const response = error.response ? error.response.data.error : {}
      let identifier
      if (response.error_subcode) identifier = response.error_subcode
      else if (response.message) identifier = response.message
      handleError(error, identifier, 'Facebook: ')
    })
}
function sortArrayofObjectes (array, field) {
  return array.sort((a, b) => a[field] - b[field]).reverse()
}
function getCurrentUser () {
  let user = JSON.parse(localStorage.getItem('outfoxUser'))
  if (!user) return null
  const selectedAdvertiserId = user.firebaseAccount ? user.firebaseAccount.selectedAdvertiser : null
  const advertiser = store.getters.getAdvertisers.find(a => a.id === selectedAdvertiserId)
  user.selectedAdAccount = advertiser ? advertiser.data.ad_account : null
  user.selectedAccount = advertiser ? advertiser.data.fb_page_id : null
  user.selectedAdvertiser = advertiser
  return user
}
function getAdvertiserById (id) {
  const advertiser = store.getters.getAdvertisers.find(a => a.id === id)
  return advertiser ? advertiser.data : {political: {}}
}
function convertFacebookAdFormat (message) {
  return {
    id: message.id,
    adset_id: message.adset_id,
    adcreative_id: message.adcreative_id,
    description: message.body,
    name: message.message_name,
    callToAction: message.call_to_action_type,
    displayLink: (message.object_story_spec && message.object_story_spec.link_data) ? message.object_story_spec.link_data.link : '',
    edit: false,
    externalUrl: message.image_url,
    file: null,
    headline: message.name,
    political: false,
    selectedPixel: false,
    preview: '',
    previewLoading: false,
    reviewFileUrl: null,
    text: (message.object_story_spec && message.object_story_spec.link_data) ? message.object_story_spec.link_data.message : '',
    url: null,
    urlParams: ''
  }
}
function handleError (err, identifier = null, from = '') {
  let message = [`${from}${err.message}`]
  let type = 'warning'
  if (identifier) {
    message = [`${from}${err.response.data.error['error_user_msg']}`]
    const errors = store.getters.getErrors
    const error = errors.find(e => e.error_match_id === identifier.toString())
    if (error) {
      message = error.exception_messages
      type = error.severity.value
    }
    if (error && error.permanent) {
      store.commit('notifications/CREATE_PERMANENT_NOTIFICATION', {type, message})
    }
    if (error && error.in_notification) {
      store.dispatch('createNotification', {message})
    }
  }
  store.dispatch('stopSpinner')
  store.dispatch('showNotification', {
    type,
    message
  })
  Sentry.captureException(`${from}${err.message}`)
  console.log(err)
}

// Format numbers
// Input int
// const getFilter = (number, filter) => {
//   if (filter === 'thousands') {
//     return number.toLocaleString()
//   // } else if (filter === 'currency') {
//   //   return '$' + parseFloat(number).toFixed(2)
//   } else if (filter === 'currency-round') {
//     return '$' + number
//   // } else if (filter === 'percent') {
//   //   return parseFloat(number).toFixed(1) + '%'
//   // } else if (filter === 'campaignType') {
//   //   return number.substr(3)
//   } else return number
// }

// Copy text to clipboard
// Source: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
export const copyTextToClipboard = (text) => {
  var textArea = document.createElement("textarea")

  //
  // *** This styling is an extra step which is likely not required. ***
  //
  // Why is it here? To ensure:
  // 1. the element is able to have focus and selection.
  // 2. if element was to flash render it has minimal visual impact.
  // 3. less flakyness with selection and copying which **might** occur if
  //    the textarea element is not visible.
  //
  // The likelihood is the element won't even render, not even a
  // flash, so some of these are just precautions. However in
  // Internet Explorer the element is visible whilst the popup
  // box asking the user for permission for the web page to
  // copy to the clipboard.
  //

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em'
  textArea.style.height = '2em'

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0

  // Clean up any borders.
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent'

  textArea.value = text

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    // eslint-disable-next-line no-unused-vars
    var successful = document.execCommand('copy')
    // var msg = successful ? 'successful' : 'unsuccessful'
    // console.log('Copying text command was ' + msg)
  } catch (err) {
    console.log('Oops, unable to copy')
  }

  document.body.removeChild(textArea)
}

// Renderer: Safely render HTML links
export const eventURLRenderer = (instance, td, row, col, prop, value, cellProperties) => {
  td.innerHTML = '<a href="https://www.mobilize.us/event/' + value + '/" target="_blank">' + value + '</a></p>'

  return td
}

// Renderer: Ad preview
export const adPreviewRenderer = (instance, td, row, col, prop, value, cellProperties) => {
  td.innerHTML = '<div class="htCenter"><i aria-hidden="true" class="v-icon notranslate material-icons theme--light blue--text text--darken-3" style="font-size: 36px;">visibility</i></div>'

  return td
}

// Renderer: Map preview
export const mapPreviewRenderer = (instance, td, row, col, prop, value, cellProperties) => {
  td.innerHTML = '<div class="htCenter"><i aria-hidden="true" class="v-icon notranslate material-icons theme--light blue--text text--darken-3" style="font-size: 36px;">map</i></div>'

  return td
}

// Remove line breaks
const noLineBreaks = (text) => {
  return text.replace(/(\r\n|\n|\r)/gm, ' ')
}

// Remove curly quotes and double-spaces
const cleanText = (text) => {
  return text.replace(/['\u2018\u2019]/g, "'")
  .replace(/["\u201C\u201D]/g, '"')
  .replace(/ /g, ' ')
}

// Make sentence case
const sentenceCase = (text) => {
  return text.substring(0, 1).toUpperCase() + text.substring(1).toLowerCase()
}

// Make title case
// eslint-disable-next-line no-unused-vars
const titleCase = (string) => {
  let sentence = string.toLowerCase().split(" ")
  for (var i = 0; i < sentence.length; i++) {
     sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1)
  }
  return sentence.join(" ")
}

// Replace underscores with spaces
const underscoresToSpaces = (text) => {
  return text.replace(/_/g, ' ')
}

/**
 * @description Get exact number of sentences from text
 * @description import in other file as - const { extractSentencesFromText } = require('./functions')
 * @param {string} text
 * @param {number} numberOfSentences
 * @return {string}
 */
const extractSentencesFromText = (text, numberOfSentences) => {
  // Regex. Source: https://stackoverflow.com/a/25736082
  // Added exclamation point to it
  const re = /(?<!\w\.\w.)(?<![A-Z][a-z]\.)(?<=\.|\?|!)\s/
  return cleanText(noLineBreaks(text)).split(re).slice(0, numberOfSentences).join(' ')
}

// Normalize Mobilize location data
const locationFormat = (location, parameter) => {
  // Check that location exists
  if (location) {
    if (parameter === 'venue') {
      return location.venue
    } else if (parameter === 'address') {
      return location.address_lines[0]
    } else if (parameter === 'locality') {
      return location.locality
    } else if (parameter === 'region') {
      return location.region
    } else if (parameter === 'postal_code') {
      return location.postal_code
    } else if (parameter === 'lat') {
      if (location.hasOwnProperty('location')) {
        return location.location.latitude
      } else {
        return ''
      }
    } else if (parameter === 'lng') {
      if (location.hasOwnProperty('location')) {
        return location.location.longitude
      } else {
        return ''
      }
    }
  } else {
    return ''
  }
}

// Add location to ad text
const addLocationText = (location) => {
  if (location !== '') {
    return '  Right here in ' + location + '!'
  } else {
    return ''
  }
}

// Add location to ad text
const addGeoRadius = (location) => {
  if (location !== '') {
    return 'Same state'
  } else {
    return 'National'
  }
}

// Estimate budget reach
const estimateReach = (budget) => {
  return Math.round(budget * 1000 / 15, 0)
}

// Estimate number of signups for the budget
const estimateConversions = (budget) => {
  return Math.round(budget / 15, 0)
}

// Normalize Mobilize Data
export const normalizeMobilizeData = rawData => {
  return rawData.map(({
    id,
    featured_image_url,
    description,
    title,
    timeslots,
    event_type,
    location,
    browser_url,
    sponsor
  }) => ({
    event_id: id,
    event_title: title,
    ad_exists: false,
    image_url: featured_image_url,
    ad_text: (extractSentencesFromText(description, 2) + addLocationText(locationFormat(location, 'locality'))),
    ad_headline: title,
    ad_link_description: ('Come join us on ' + moment(timeslots[0].start_date * 1000).format('ddd, MMM Do') + '!'),
    event_type: sentenceCase(underscoresToSpaces(event_type)),
    location_venue: locationFormat(location, 'venue'),
    location_address: locationFormat(location, 'address'),
    location_locality: locationFormat(location, 'locality'),
    location_region: locationFormat(location, 'region'),
    location_postal_code: locationFormat(location, 'postal_code'),
    lat: locationFormat(location, 'lat'),
    lng: locationFormat(location, 'lng'),
    browser_url,
    sponsor_name: sponsor.name,
    audience: 'Email_Grass_2021',
    geo_target: addGeoRadius(locationFormat(location, 'locality')),
    start_date: moment().format('MMM D'),
    start_time: moment().format('h:mm A'),
    end_date: moment(timeslots[0].start_date * 1000).format('MMM D'),
    end_time: '8PM day before',
    budget: 300,
    est_reach: estimateReach(300),
    est_conversions: estimateConversions(300)
  }))
}

// Normalize AdSet Data
export const normalizeAdSetData = rawData => {
  return rawData.map(({
    CampaignName,
    AdSetName,
    AdSetDailyBudget,
    AdSetLifetimeBudget,
    AdSetTimeStart,
    AdSetTimeEnd,
    Subcities,
    CampaignObjective
  }) => ({
    CampaignName,
    goal: 'Acquisition',
    AdSetName,
    AdSetDailyBudget,
    AdSetLifetimeBudget,
    AdSetTimeStart,
    AdSetTimeEnd,
    audience: '1',
    audience_splits: 'None',
    geo: Subcities,
    geo_splits: 'None',
    success_metric: CampaignObjective,
    pixel: "350.org Pixel",
    conversion_event: "Landing page view"
    //
    //
    // ad_exists: false,
    // image_url: featured_image_url,
    // ad_text: (extractSentencesFromText(description, 2) + addLocationText(locationFormat(location, 'locality'))),
    // ad_headline: title,
    // ad_link_description: ('Come join us on ' + moment(timeslots[0].start_date * 1000).format('ddd, MMM Do') + '!'),
    // event_type: sentenceCase(underscoresToSpaces(event_type)),
    // location_venue: locationFormat(location, 'venue'),
    // location_address: locationFormat(location, 'address'),
    // location_locality: locationFormat(location, 'locality'),
    // location_region: locationFormat(location, 'region'),
    // location_postal_code: locationFormat(location, 'postal_code'),
    // lat: locationFormat(location, 'lat'),
    // lng: locationFormat(location, 'lng'),
    // browser_url,
    // sponsor_name: sponsor.name,
    // audience: 'Volunteers 1% LAL',
    // geo_target: '+3 mi',
    // start_date: moment().format('MMM D'),
    // start_time: moment().format('h:mm A'),
    // end_date: moment(timeslots[timeslots.length - 1].end_date * 1000).format('MMM D'),
    // end_time: '8PM day before',
    // budget: 300,
    // est_reach: estimateReach(300),
    // est_conversions: estimateConversions(300)
  }))
}

// Return formatted InfoWindow
const infoWindow = (event) => {
  return '<div>' +
        '<p>' + event.event_type + '</p>' +
        '<h4>' + event.event_title + '</h4><p></p>' +
        '<p>' + event.location_venue + '<br>' +
        event.location_address + '<br>' +
        event.location_locality + ', ' + event.location_region + ' ' + event.location_postal_code + '</p>' +
        '<p><a href="' + event.browser_url + '" target="_blank">Event page</a></p>' +
        '</div>'
}

// Generate Google Map pin symbol
const pinSymbol = (color = 'lightgray') => {
  // Source: https://risanb.com/posts/colorful-google-maps-marker/
  // Marker SVG Path: https://material.io/tools/icons/?icon=place&style=baseline
  return {
    path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    fillColor: color,
    fillOpacity: 1,
    strokeColor: '#3b5998',
    strokeWeight: 1,
    scale: 1.4,
    anchor: { x: 12, y: 24 }
  }
}

// Color code pins
const eventPin = (event_type) => {
  if (event_type === 'Phone bank') {
    return pinSymbol('red')
  } else if (event_type === 'Canvass') {
    return pinSymbol('blue')
  } if (event_type === 'Text bank') {
    return pinSymbol('orange')
  }
}

// Get array of Google Maps markers
export const toGMapMarkers = rawCoords => {
  return rawCoords.map((event, index) => ({
    id: index + event.event_title,
    title: event.event_title,
    icon: eventPin(event.event_type),
    infoText: infoWindow(event),
    position: {
      lat: event.lat,
      lng: event.lng
    }
  }))
}

// Get array of Google Maps circles
export const toGMapCircles = rawCoords => {
  const mile_in_m = 1609.344

  return rawCoords.map((circle, index) => ({
    id: index + circle.lat,
    center: {
      lat: circle.lat,
      lng: circle.lng
    },
    radius: (3 * mile_in_m)
  }))
}

export default {
  countTotal,
  getMessagePreview,
  sortArrayofObjectes,
  getCurrentUser,
  getAdvertiserById,
  convertFacebookAdFormat,
  handleError
}
